import { render } from "./TabbyWrapper.vue?vue&type=template&id=031acf64&scoped=true"
import script from "./TabbyWrapper.vue?vue&type=script&lang=js"
export * from "./TabbyWrapper.vue?vue&type=script&lang=js"

import "./TabbyWrapper.vue?vue&type=style&index=0&id=031acf64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-031acf64"

export default script